import { PolicyResponseDto } from '@policyvision/contracts';

import { Client } from '@/common/services/Client';
import { PolicyValidationAssembler } from '@/policy/api/assembler/PolicyValidationAssembler';
import { FrontendPolicyValidationResult } from '@/policy/contexts/ValidationContext';

export async function pausePolicy(
  uuid: string,
  validations: FrontendPolicyValidationResult,
): Promise<void> {
  const requestBody: PolicyResponseDto = {
    validationResult:
      PolicyValidationAssembler.assemblePolicyValidationResult(validations),
  };

  await Client.post({
    endpoint: `/policies/${uuid}/pause`,
    body: requestBody,
  });
}
